import React, { Component } from "react"
import styles from "./App.module.css"
import metronome from "./images/metronome.png"
import metronomeBlack from "./images/metronome-black.png"
// import Beats from "./components/Beats"
import BPMSigns from "./components/BPM-Signs"
import BPMName from "./components/BPM-Name"
import BPMNameSelect from "./components/BPM-Selected-Name"
// import Notations from "./components/Notations"
import metrosound from "./audio/Metronome.mp3"
import Mute from "./components/Mute"
import StartButton from "./components/StartButton"
import Skin from "./components/Skin"
import sliderStyles from "./css/slider.module.css"

class App extends Component {
  componentDidMount() {
    if (localStorage.getItem("skinDark") === "false") {
      this.skinChange()
    }

    if (localStorage.getItem("bpm") !== null) {
      this.setState({
        bpm: localStorage.getItem("bpm"),
        bpmName: BPMNameSelect(localStorage.getItem("bpm"))
      })
    }
  }

  state = {
    bpm: 120,
    bpmName: "",
    timeSignature: "",
    metronomeStart: false,
    play: false,
    soundMute: false,
    skinDark: true,
    skin: {
      app: styles.App,
      bpmSigns: styles.BPMSigns,
      bpmButton: styles.BPMButton,
      bpmName: styles.BPMName,
      slider: sliderStyles.Slider,
      logo: metronome
    }
  }

  timerIntervalID
  timerTimeoutID
  metronomeIntervalID
  changeBPMClicked
  // audio = new Audio(metrosound)
  counter = 0

  pressingDown(sign) {
    // Start the timer
    if (this.state.bpm <= 20 || this.state.bpm >= 240) {
      return
    }
    if (this.state.metronomeStart) {
      this.metronomeStartEnd()
      this.changeBPMClicked = true
    }
    this.timerTimeoutID = setTimeout(() => {
      this.timerIntervalID = setInterval(() => this.timer(sign), 150)
    }, 500)
  }

  notPressingDown() {
    setTimeout(() => {
      if (this.changeBPMClicked) {
        this.metronomeStartEnd()
      }
    }, 500)

    // Stop the timer
    clearTimeout(this.timerTimeoutID)
    clearInterval(this.timerIntervalID)
    setTimeout(() => localStorage.setItem("bpm", this.state.bpm), 100)
    this.counter = 0
  }

  timer(sign) {
    this.counter += 1

    if (sign === "-") {
      this.setState({
        bpm: this.state.bpm - 1,
        bpmName: BPMNameSelect(this.state.bpm)
      })
    } else if (sign === "+") {
      this.setState({
        bpm: this.state.bpm + 1,
        bpmName: BPMNameSelect(this.state.bpm)
      })
    }
  }

  soundMute() {
    if (!this.state.soundMute) {
      this.setState({ soundMute: true })
      this.audio.muted = true
    } else {
      this.setState({ soundMute: false })
      this.audio.muted = false
    }
  }

  metronomeStartEnd() {
    let soundInterval = (60 / parseInt(this.state.bpm)) * 1000 + 20
    if (!this.state.metronomeStart) {
      this.setState({ metronomeStart: true, play: true })
      this.metronomeIntervalID = setInterval(
        () => this.audio.play(),
        soundInterval
      )
    } else {
      this.setState({ metronomeStart: false, play: false })
      clearInterval(this.metronomeIntervalID)
    }
  }

  skinChange() {
    if (!this.state.skinDark) {
      this.setState({
        skinDark: true,
        skin: {
          app: styles.App,
          bpmSigns: styles.BPMSigns,
          bpmButton: styles.BPMButton,
          bpmName: styles.BPMName,
          slider: sliderStyles.Slider,
          logo: metronome
        }
      })
      localStorage.setItem("skinDark", true)
    } else {
      this.setState({
        skinDark: false,
        skin: {
          app: styles.AppLight,
          bpmSigns: styles.BPMSignsLight,
          bpmButton: styles.BPMButtonLight,
          bpmName: styles.BPMNameLight,
          slider: sliderStyles.SliderLight,
          logo: metronomeBlack
        }
      })
      localStorage.setItem("skinDark", false)
    }
  }

  render() {
    return (
      <div className={this.state.skin.app}>
        <audio
          src={metrosound}
          ref={audio => {
            this.audio = audio
          }}
          type='audio/mpeg'
        />
        <header className={styles.Appheader}>
          <img
            src={this.state.skin.logo}
            alt='Logo Metronome'
            style={{ width: "25px", marginRight: "7px" }}
          />
          <span style={{ fontWeight: "300", fontFamily: "inherit" }}>
            Metronomo
          </span>
        </header>
        {/* <div className={styles.VisualBeats}>
          <Beats />
          <Beats />
          <Beats />
          <Beats />
        </div> */}
        <span className={styles.LineDivider} style={{ margin: "2px 0px" }} />
        <div className={styles.VisualBPM}>
          <BPMSigns
            sign='-'
            skin={this.state.skin.bpmSigns}
            click={() => {
              if (this.state.bpm > 20) {
                this.setState({
                  bpm: this.state.bpm - 1,
                  bpmName: BPMNameSelect(this.state.bpm)
                })
              }
            }}
            mousedown={() => this.pressingDown("-")}
            mouseup={() => this.notPressingDown()}
            // mouseleave={() => this.notPressingDown()}
            touchstart={() => this.pressingDown("-")}
            touchend={() => this.notPressingDown()}
          />
          <button className={this.state.skin.bpmButton} disabled>
            <span className={styles.BPMNumber}>{this.state.bpm}</span>
            <span className={styles.BPMText}>BPM</span>
          </button>
          <BPMSigns
            sign='+'
            skin={this.state.skin.bpmSigns}
            click={() => {
              if (this.state.bpm < 240) {
                this.setState({
                  bpm: this.state.bpm + 1,
                  bpmName: BPMNameSelect(this.state.bpm)
                })
              }
            }}
            mousedown={() => this.pressingDown("+")}
            mouseup={() => this.notPressingDown()}
            // mouseleave={() => this.notPressingDown()}
            touchstart={() => this.pressingDown("+")}
            touchend={() => this.notPressingDown()}
          />
        </div>
        <div className='Slider-Container'>
          <input
            type='range'
            className={this.state.skin.slider}
            min='20'
            max='240'
            value={this.state.bpm}
            step='1'
            onChange={slider => {
              if (this.state.metronomeStart === true) {
                this.metronomeStartEnd()
                this.changeBPMClicked = true
              }
              this.setState({
                bpm: parseInt(slider.target.value),
                bpmName: BPMNameSelect(this.state.bpm)
              })
              localStorage.setItem("bpm", this.state.bpm)
            }}
            onClick={slider => {
              this.setState({
                bpm: parseInt(slider.target.value),
                bpmName: BPMNameSelect(this.state.bpm)
              })
              localStorage.setItem("bpm", this.state.bpm)
            }}
            onMouseUp={() => {
              if (this.changeBPMClicked === true) {
                this.metronomeStartEnd()
                this.changeBPMClicked = false
              }
            }}
            // onMouseLeave={() => {
            //   if (!this.state.metronomeStart) {
            //     this.metronomeStartEnd()
            //   }
            // }}
            onTouchEnd={() => {
              if (this.changeBPMClicked === true) {
                this.metronomeStartEnd()
                this.changeBPMClicked = false
              }
            }}
          />
        </div>
        <div className={styles.BPMNameContainer}>
          <BPMName
            bpm={this.state.bpm}
            bpmname={this.state.bpmName}
            skin={this.state.skin.bpmName}
          />
        </div>
        {/* <span className={styles.LineDivider} /> */}
        {/* <div className={styles.Notations}>
          <div className={styles.NotationsItems}>
            <Notations
              change={notation =>
                this.setState({
                  timeSignature: notation.target.value
                })
              }
            />
          </div>
          <span className={styles.VerticalDivider} />
          <div className={styles.NotationsItems}>
            <select className={styles.NotationsItemsSelect} disabled>
              <option>Default Sound</option>
            </select>
          </div>
          <span className={styles.VerticalDivider} />
          <div className={styles.NotationsItems}>
            <select className={styles.NotationsItemsSelect} disabled>
              <option>Subdivision</option>
            </select>
          </div>
        </div> */}
        <span className={styles.LineDivider} />
        <div className={styles.Commands}>
          <div className={styles.CommandsItems}>
            <Mute
              soundmute={this.state.soundMute}
              click={() => this.soundMute()}
              skindark={this.state.skinDark}
            />
          </div>
          <div className={styles.CommandsItems}>
            <StartButton
              click={() => this.metronomeStartEnd()}
              img={this.state.metronomeStart}
              skindark={this.state.skinDark}
            />
          </div>
          <div className={styles.CommandsItems}>
            <Skin
              skindark={this.state.skinDark}
              click={() => this.skinChange()}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default App
